import { z } from 'zod';

export const userSchema = z.object({
  id: z.string(),
  profile: z.instanceof(File).optional(),
  firstName: z
    .string()
    .trim()
    .min(1, { message: 'First name is required.' })
    .min(3, {
      message: 'First name must be at least 3 characters.',
    })
    .max(30, { message: 'First name must be at most 30 characters.' }),
  lastName: z
    .string()
    .trim()
    .min(1, { message: 'Last name is required.' })
    .min(3, {
      message: 'Last name must be at least 3 characters.',
    })
    .max(30, { message: 'Last name must be at most 30 characters.' }),
  email: z
    .string()
    .trim()
    .min(1, { message: 'Email is required.' })
    .email({ message: 'Invalid email.' })
    .max(40, { message: 'Email must be at most 40 characters.' }),
  phone: z
    .string()
    .min(1, { message: 'Phone is required.' })
    .refine((value) => /^\d+$/.test(value), {
      message: 'Only numbers are allowed.',
    })
    .optional(),
  permissions: z.string(),
  roles: z.string().min(1, { message: 'User Type is required.' }),
  status: z.string(),
  clientId: z.number(),
  currentRole: z.string(),
});

export const userClientCreateSchema = userSchema.omit({
  id: true,
  currentRole: true,
  status: true,
  permissions: true,
});

export const userCreateSchema = userSchema.omit({
  id: true,
  currentRole: true,
  status: true,
  permissions: true,
});

export const userUpdateSchema = userSchema.pick({
  firstName: true,
  lastName: true,
  email: true,
  phone: true,
  profile: true,
});

export type Users = z.infer<typeof userSchema>;

export type UsersCreateSchema = Omit<
  Users,
  'currentRole' | 'id' | 'permissions' | 'status'
>;

export type UsersUpdateSchema = Pick<
  Users,
  'currentRole' | 'email' | 'firstName' | 'lastName' | 'phone' | 'profile'
>;
